import { IRectangleCoordinatableObject, instanceOfIRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";
import { ElementTypes } from "./ElementTypes";

export interface ITextPresentableObject extends IRectangleCoordinatableObject {
  text: string;
}

export function instanceOfITextPresentableObject<T extends ITextPresentableObject>(instance: any, type: ElementTypes): instance is ITextPresentableObject {
  return instance
      && (instance.text !== undefined)
      && instanceOfIRectangleCoordinatableObject<T>(instance, type);
}
